import {
  initClientInput,
  ClientFormState
} from '../../types/client/client.def';
import { initErrorFields } from '../../helpers/forms/error/errorFieldHelper';
import {
  ADD_CLIENT,
  CLEAR_CLIENT,
  ClientActions,
  UPDATE_RELAIS,
  COPY_DELIVERY_INFORMATIONS
} from '../actions/client.actions';
import {
  Enum_Client_Civilite,
  Enum_Client_Civilitelivraison
} from 'graphql/generated/graphql';
import { isValid } from '../../helpers/forms/error/isValid';

const initialState = {
  values: initClientInput,
  errors: initErrorFields(initClientInput),
  isValid: false,
  sameDeliveryInformation: false,
  ui: undefined
};

const clientReducer = (
  state: ClientFormState = initialState,
  action: ClientActions
): ClientFormState => {
  switch (action.type) {
    case ADD_CLIENT:
      return {
        ...state,
        ...action.payload
      };
    case COPY_DELIVERY_INFORMATIONS:
      if (state.sameDeliveryInformation) {
        if (state.values.civilite === Enum_Client_Civilite.Madame) {
          state.values.civilitelivraison = Enum_Client_Civilitelivraison.Madame;
          state.errors.civilitelivraison = false;
        } else if (state.values.civilite === Enum_Client_Civilite.Monsieur) {
          state.values.civilitelivraison =
            Enum_Client_Civilitelivraison.Monsieur;
          state.errors.civilitelivraison = false;
        }
        if (state.values.prenom) {
          state.values.prenomlivraison = state.values.prenom;
          state.errors.prenomlivraison = false;
        }
        if (state.values.nom) {
          state.values.nomlivraison = state.values.nom;
          state.errors.nomlivraison = false;
        }
        if (state.values.tel) {
          state.values.mobilelivraison = state.values.tel;
          state.errors.mobilelivraison = false;
        }
        if (state.values.villefacturation) {
          state.values.villelivraison = state.values.villefacturation;
          state.errors.villelivraison = false;
        }
        if (state.values.adressefacturation) {
          state.values.adresselivraison = state.values.adressefacturation;
          state.errors.adresselivraison = false;
        }
        if (state.values.cpfacturation) {
          state.values.cplivraison = state.values.cpfacturation;
          state.errors.cplivraison = false;
        }
      }

      const checkValid = () => {
        if (
          state.values.methodepaiement !== undefined &&
          state.errors.methodepaiement !== undefined
        ) {
          return isValid(state.errors);
        } else {
          return false;
        }
      };

      return {
        ...state,
        isValid: checkValid()
      };
    case UPDATE_RELAIS:
      return {
        ...state,
        values: {
          ...state.values,
          adresselivraison: action.payload.adresse1,
          cplivraison: action.payload.codePostal.toString(),
          villelivraison: action.payload.localite,
          relaisid: action.payload.identifiant,
          nompointrelais: action.payload.nom,
          isrelais: true
        },
        ui: {
          nompointrelais: action.payload.nom
        }
      };
    case CLEAR_CLIENT:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default clientReducer;
